var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('link-list',{attrs:{"linkable-id":_vm.guideBookPaper.id,"linkable-type":"GuideBookPaper"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }